import { render, staticRenderFns } from "./OsDetectionTool.vue?vue&type=template&id=1a90aaba&scoped=true"
import script from "./OsDetectionTool.vue?vue&type=script&lang=js"
export * from "./OsDetectionTool.vue?vue&type=script&lang=js"
import style0 from "./OsDetectionTool.vue?vue&type=style&index=0&id=1a90aaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90aaba",
  null
  
)

export default component.exports